import { IAuditEventData, UserPageViewAuditSnapshotV1 } from 'api'
import { Box } from 'cs-kevlar-react'
import React from 'react'
import { serverDateToLocaleDateTimeString } from 'utils/dates'
import { DetailField } from './DetailField'
import { UnavailableDetails } from './UnavailableDetails'
import { useDetailStyles } from './useDetailStyles'
import { resolveEventData } from './utils'

interface UserActivityDetailsProps {
  eventData: IAuditEventData
}

export const PageViewDetails: React.FunctionComponent<UserActivityDetailsProps> = ({
  eventData,
}) => {
  const snapshot = resolveEventData<UserPageViewAuditSnapshotV1>(
    eventData,
    nameof<UserPageViewAuditSnapshotV1>(),
  )

  if (!snapshot) return <UnavailableDetails />

  const classes = useDetailStyles()

  return (
    <React.Fragment>
      {snapshot && (
        <Box className={classes.fieldsContainer}>
          <DetailField label="Title" original={snapshot.title} />
          <DetailField label="URL" original={snapshot.url} />
          <DetailField
            label="Started"
            original={serverDateToLocaleDateTimeString(
              snapshot.startedTimestamp,
            )}
          />
          <DetailField
            label="Completed"
            original={serverDateToLocaleDateTimeString(
              snapshot.completedTimestamp,
            )}
          />
          <DetailField
            label="Duration"
            original={snapshot.durationDescription}
          />
        </Box>
      )}
    </React.Fragment>
  )
}
